<template>
    <page>
        <module title="砍价活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>

                    <c-detail-item label="砍价有效期">{{activityInfo.valid_time}}小时</c-detail-item>

                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>

                    <c-detail-item label="允许自砍">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.is_self_bargain == 0" style="color: darkgrey">不允许</span>
                            <span v-if="activityInfo.is_self_bargain == 1" style="color: darkgreen">允许</span>
                        </template>
                        {{}}
                    </c-detail-item>

                    <c-detail-item label="发起人数">{{activityInfo.launch_count}}</c-detail-item>

                    <c-detail-item label="帮砍人次">{{activityInfo.bargain_count}}</c-detail-item>

                    <c-detail-item label="订单数">{{activityInfo.order_count}}</c-detail-item>

                    <c-detail-item label="砍至底价人数">{{activityInfo.bargain_success_count}}</c-detail-item>

                    <c-detail-item label="底价成交订单">{{activityInfo.min_price_order_count}}</c-detail-item>

                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                                    <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="现售价"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="是否底价下单"
                                    name="min_price_order"
                                    width="110"
                            >
                                <template v-slot="{data}">{{data.min_price_order == 1 ? "必须底价下单" : "允许中途下单"}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="帮砍人数"
                                    name="bargain_user_limit"
                                    width="70"
                            ></c-table-column>

                            <c-table-column
                                    label="帮砍底价"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    ￥{{data.min_sale_price}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="活动库存(单SKU)"
                                    name="activity_stock_count"
                                    width="80"
                            >
                            </c-table-column>


                            <c-table-column
                                    label="活动销量(总数)"
                                    name="sale_count"
                                    width="80"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="商品状态"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 1" style="color:red">禁用</span>
                                    <span v-if="data.state == 2" style="color:green">启用</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_bargain_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                userLevelStr: '',
                userLevelArr: [],
                productList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activityBargain/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>